// `verdict_full` — renommé « IA Analyse » (arbitrage Axel du 2026-08-16).
//
// POURQUOI PAS « Raisonnement IA » : le titre laissait croire que le bloc expliquait le
// score. Il ne le peut pas. Le LLM tourne AVANT le calcul et ne voit jamais le score
// final : celui-ci vaut `critères × 0,6 + note IA × 0,4`, puis knockout, plafonds et
// retraits. Quand ce texte est écrit, le chiffre n'existe pas encore. C'est un avis sur
// le profil, pas une justification du score — c'est `ScoreExplanation` qui porte
// l'arithmétique.
//
// POURQUOI ON AÈRE SANS CLASSER : le texte arrive en un bloc de ~565 caractères. Le
// découper en « points forts / réserves » serait faux environ une fois sur trois — sur
// 16 212 verdicts, 36 % portent deux marqueurs d'opposition concurrents, et le motif
// « Bien qu'il n'ait pas X, ses responsabilités sont transférables » présente un point
// FORT en concession. On sépare donc les phrases, sans rien prétendre de leur rôle.
// L'éclaté sémantique doit venir du schéma de réponse du moteur.

import React from 'react';
import { Sparkles } from 'lucide-react';
import { splitSentences } from '../../lib/mappers/match.mapper';

interface Props {
    verdict?: string;
}

const AiAnalysis: React.FC<Props> = ({ verdict }) => {
    const sentences = splitSentences(verdict);
    if (sentences.length === 0) return null;

    return (
        <div className="bg-white border border-indigo-100 rounded-xl overflow-hidden">
            <div className="px-3 py-2 bg-indigo-50 border-b border-indigo-100 flex items-center gap-1.5">
                <Sparkles size={11} className="text-indigo-500" />
                <h4 className="text-[10px] font-bold text-indigo-700 uppercase tracking-wider">IA Analyse</h4>
            </div>
            {/* Pas d'italique : sur cinq lignes, elle est la première cause d'illisibilité
                du bloc d'origine. */}
            <ul className="px-3 py-2.5 space-y-1.5">
                {sentences.map((s, i) => (
                    <li key={i} className="flex items-start gap-2 text-[11px] text-slate-600 leading-relaxed">
                        <span className="mt-[7px] w-1 h-1 rounded-full bg-indigo-300 shrink-0" />
                        <span>{s}</span>
                    </li>
                ))}
            </ul>
        </div>
    );
};

export default AiAnalysis;
